import { render, staticRenderFns } from "./content-component.vue?vue&type=template&id=74310278"
import script from "./content-component.vue?vue&type=script&lang=js"
export * from "./content-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports